<template>
    <content-view>
        <!-- 权限管理－新增员工 -->
        <div class="wrap-container-in">
            <a-form :form="form" class="level-form" @submit="handleSubmit">
                <a-form-item label="员工姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input
                        placeholder="请输入"
                        v-decorator="['name',{rules: [{required: true, message: '请输入员工姓名',}]}]"
                    ></a-input>
                </a-form-item>
                <a-form-item label="员工手机" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input
                        @blur="checkExist('phone')"
                        placeholder="请输入"
                        v-decorator="['phone',{rules: [{ required: true, message: '请输入手机号', whitespace:true }, {message: '手机号格式有误', pattern:/^1[0-9]{10}$/}]}]"
                    ></a-input>
                </a-form-item>
                <a-form-item label="员工角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['roleId',{rules: [{required: true, message: '请选择员工角色',}]}]" placeholder="请选择">
                        <a-select-option v-for="item in options" :key="item.id" :value="item.id">{{item.roleName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="门店权限" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select mode="multiple" allowClear :options="shopList" placeholder="请选择" v-decorator="['shopIdList',{rules: [{required: true, message: '请选择'}]}]"></a-select>
                </a-form-item>
                <a-form-item label="登录账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input
                        @blur="checkExist('account')"
                        placeholder="请输入"
                        v-decorator="['account',{rules: [{required: true, message: '请输入登录账号',}]}]"
                    ></a-input>
                </a-form-item>
                <a-form-item label="登录密码" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="!id">
                    <a-input
                        autocomplete="new-password"
                        placeholder="请输入"
                        type="password"
                        v-decorator="['password', {validateFirst: true, rules: [{ required: true, message: '请输入' }, {min: 6, message: '密码需要6位或以上'}, {max: 20, message: '密码需要20位或以下'}, customValidator()]}]"
                    ></a-input>
                </a-form-item>
                <a-form-item label="备注/教师简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-textarea
                        placeholder="请输入"
                        v-decorator="['description']"
                    ></a-textarea>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="$router.go(-1)">取消</a-button>
                    <a-button type="primary" html-type="submit">确认</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
export default {
    name: "",
    components: {},
    props: {},
    data() {
        return {
            labelCol: { span: 8 },
            wrapperCol: { span: 10 },
            row: {},
            options: [],
            flagAccount: false, // 账号是否重复
            flagPhone: false, // 电话是否重复
            shopList: [],
        };
    },
    computed: {
        id(){
            return this.$route.query.id
        },
        ...mapGetters(["shopId"])
    },
    methods: {
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                res.push({name: '总平台',id: '-1'})
                res.forEach(i => {
                    i.label = i.name;
                    i.value = i.id;
                })
                this.shopList = res;
            });
        },
        handleSubmit(e) {
            e.preventDefault();
            if(this.flagAccount) {
                this.$message.error('员工账号不能重复，请重新输入')
                return false
            }
            if(this.flagPhone) {
                this.$message.error('员工手机号不能重复，请重新输入')
                return false
            }
            this.form.validateFields((err, values) => {
                if (err) return;
                values.roleIdList = [ values.roleId ];
                delete values.roleId;
                this.$api.jurisdiction[this.id ? 'editUser' : 'addUser']({
                        body: {
                            ...values,
                            id: this.id,
                            shopId: this.shopId
                        }
                    }).then(data => {
                        this.$message.success('操作成功！');
                        this.$router.go(-1);
                    });
            });
        },
        // 检查员工账号/手机号是否存在
        checkExist(field) {
            let values = {
                staffId: this.id ? this.id : undefined,
                [field]: this.form.getFieldValue(field),
            }
            this.$api.jurisdiction.checkExist({ 
                body: values
            }).then(res => {
                if(res) {
                    this.$message.error(`员工${field === 'account' ? '账号' : '手机号'}不能重复，请重新输入`);
                }
                if (field === 'account') {
                    this.flagAccount = res;
                } else {
                    this.flagPhone = res;
                }
            });
        },
        // 校验密码
        customValidator() {
            return ({validator: (rule, value, callback) => {
                let userNameReg = new RegExp(this.form.getFieldValue('name'));
                let userPhoneReg = new RegExp(this.form.getFieldValue('phone'));
                let accountReg = new RegExp(this.form.getFieldValue('account'));
                let simplePasswordReg = new RegExp('123456');
                let passwordReg = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z])).{6,20}/;
                if (userNameReg.test(value)) {
                    callback('密码不得与员工名称相同');
                }
                if (userPhoneReg.test(value)) {
                    callback('密码不得与员工手机号相同');
                }
                if (accountReg.test(value)) {
                    callback('密码不得与员工账号相同');
                }
                if (simplePasswordReg.test(value)) {
                    callback('密码不得包含123456');
                }
                if (!passwordReg.test(value)) {
                    callback('密码需要包含大小写英文、特殊符号、数字中的任意两类');
                }
                callback();
            }})
        },

        // 获取员工详情
        getDetail() {
            this.$api.jurisdiction.userDetail({
                params: {
                    id: this.id
                }
            }).then(res => {
                let { name, account, phone, description } = res;
                console.log(name);
                this.form.setFieldsValue({
                    name,
                    account,
                    phone,
                    description,
                    roleId: Array.isArray(res.roleIdList) ? res.roleIdList[0] : null,
                    shopIdList: res.shopIdList
                });
            });
        },

        // 获取角色列表
        getRoleList() {
            if(!this.shopId) return;
            this.$api.jurisdiction.selectList({}).then(data => {
                this.options = data;
            })
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getShopList();
        this.getRoleList();
        if (this.id) {
            this.getDetail();
        }
    },
    watch: {
        'shopId'(val) {
            this.getRoleList()
        }
    }
};
</script>
<style lang="scss" scoped>
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
    .level-form {
        margin: 0 auto;
        .ant-input-number {
            width: 100%;
        }
        .age-input {
            width: calc(50% - 21px);
            text-align: center;
            &-right {
                border-left: 0;
            }
        }
    }
}
</style>
